export default "__VITE_ASSET__BcjAnqLC__"